
export default {
  name: 'ButtonComponent',
  props: {
    icon: {
      type: String,
      default: () => '',
    },
    handleClick: {
      type: Function,
      default: () => {},
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    color: {
      type: String,
      default: '#fff',
    },
    btn: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    colorClass() {
      return `color-${this.color}`
    },
    typeButton() {
      return `btn-${this.btn}`
    },
  },
}
